export function getMeta(url, callback) {
  var img = new Image();
  img.src = url;
  img.onload = function() { 
    callback((this as any).width, (this as any).height); 
  }
}

export const isImageEmbeddable = (content_type: string): boolean => {
  const contentType = content_type;
  const embeddableImageTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];

  return embeddableImageTypes.includes(contentType);
}
